<template>
  <div :class="['chapter',{activeBack: ishover == indexData}]" @click.stop.prevent="toggleChaper(chaperData)" @mouseenter="mouseenter(indexData)" @mouseleave="mouseleave(indexData)">
    <div class="weibaocun" v-if="!chaperData.saveStatus"><i class="icon iconfont icon-dian"></i></div>
    <div class="title">
      <input 
        v-model="chaperData.courseName" 
        @input="changeName()" 
        v-focus="{cls: indexData, foc: focusState }" 
        :readonly="isreadonly !=indexData" @blur="breakInput()">
    </div>
    <div class="time">
      <p class="create-time">{{chaperData.updatedAt ? chaperData.updatedAt.split(' ')[0] : ''}}</p>
    </div>
    <div class="icons" v-if="ishover == indexData">
      <i class="icon iconfont icon-edit" @click.stop.prevent="editorTitle" ></i>
      <i class="icon iconfont icon-delete1" @click.stop.prevent="deleteItem" ></i>
      <i class="icon iconfont icon-save" @click.stop.prevent="updateItem" v-if="!chaperData.saveStatus"></i>
      <i class="icon iconfont icon-daochu" @click.stop.prevent="exportItem"></i>
    </div>
  </div>
</template>

<script>
  import EventBus from '@/views/eventBus'
  export default{
    props: {
      chaperData: {
        type: Object,
        default: function() {
          return {
            saveStatus: true
          }
        }
      },
      indexData: {
        type: Number
      }
    },
    data() {
      return {
        ischoosed: 0,
        isreadonly: -1,
        focusState: '',
        flag: '',
        ishover: -1,
        isSave: ''
      }
    },
    created() {
      console.log(this.chaperData)
    },
    methods: {
      toggleChaper(data) {
        if (this.flag !== this.indexData) {
          this.isreadonly = -1
        }
        console.log('data', data)
        this.$emit('selectChapter', this.indexData)
        EventBus.$emit('showCourseCode', data.courseContent, this.indexData)
        this.$store.state.courseId = data.courseId
      },
      changeName() {
        console.log(this.chaperData.savaStatus)
        this.chaperData.saveStatus = false
      },
      editorTitle() {
        this.flag = this.indexData
        this.isreadonly = this.indexData
        this.focusState = this.indexData
        console.log(this.chaperData)
        this.toggleChaper(this.chaperData)
        this.$emit('editorTitle', this.indexData)
      },
      deleteItem() {
        EventBus.$emit('deleteChapter', this.chaperData.courseId, this.indexData)
      },
      updateItem() {
        this.isreadonly = -1
        EventBus.$emit('updateChapter', this.chaperData, this.indexData)
        EventBus.$emit('chapterOption', this.indexData)
      },
      exportItem() {
        console.log('exportItem', this.chaperData)
        EventBus.$emit('exportItem', this.chaperData)
      },
      breakInput() {
        this.focusState = ''
      },
      mouseenter(index) {
        this.ishover = index
      },
      mouseleave(index) {
        this.ishover = -1
        // if (this.isreadonly !== -1) {
        //   this.isreadonly = -1
        // }
      }
    },
    directives: {
      focus: {
        update: function (el, option) {
          var value = option.value
          if (value.foc === value.cls) {
            el.focus()
          }
        }
      }
    }
  }
</script>

<style lang="scss">
  .courseActive{
    color: #1FB6FF !important;
  }
  .chapter{
    color: #B6B6B6;
    box-sizing: border-box;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding: 4px 10px 4px 5px;
    line-height: 20px;
    width: calc(100% - 20px);
    margin: 0 0 4px 20px;
    position: relative;

    input{
      color:#3D474D;
      width: 100% !important;
      border: none;
      outline: none;
      background: transparent;
    }
    // .isInput{
    //   border: 1px solid #999;
    // }
    .title, .times {
      flex: 1;
      text-align: center;
    }
    .weibaocun{
      position: absolute;
      left: -10px;
    }
    .icons{
      margin-left:10px;
    }
    .activeBack{
      background: rgba(31, 185, 255, .05)
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?573c4a60